import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import {
  LiveClass,
  LiveClassStatus,
} from '../../shared/core/state/live-class/models/live-class';
import { Store } from '@ngrx/store';
import { State } from '../../shared/core/state';
import { ActivatedRoute, Router } from '@angular/router';

import * as LiveClassActions from '../../shared/core/state/live-class/live-class.action';
import { Subject, takeUntil } from 'rxjs';
import { FormatterService } from '../../shared/util/formatter.service';
import { toLiveClassCardViewModel } from '../../shared/util/ui-card.mapper';
import { UiCardViewModel } from '@black/ui';
import { TenantService } from '../../shared/services/tenant.service';

@Component({
  selector: 'black-add-live-class-success',
  templateUrl: './add-live-class-success.component.html',
  styleUrl: './add-live-class-success.component.css',
  standalone: false,
})
export class AddLiveClassSuccessComponent implements OnInit, OnDestroy {
  private store = inject<Store<State>>(Store);
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private formatter = inject(FormatterService);
  private tenantService = inject(TenantService);

  createdLiveClass: LiveClass | null = null;
  createdLiveClassCard: UiCardViewModel | null = null;
  isAutoPublishEnabled = false;

  onDestroy$ = new Subject();

  ngOnInit(): void {
    this.tenantService.currentTenant$
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((tenant) => {
        this.isAutoPublishEnabled =
          tenant?.settings?.features?.autoPublishLiveClasses !== false;
      });

    this.store
      .select((state) => state.liveClass.createdLiveClassItem)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((item) => {
        this.createdLiveClass = item;
        this.createdLiveClassCard = item
          ? toLiveClassCardViewModel(item, this.formatter, {
              showButtons: false,
            })
          : null;

        if (
          item?.status === LiveClassStatus.UNDER_REVIEW ||
          item?.status === LiveClassStatus.PUBLISHED
        ) {
          this.router.navigate(['/instructor']);
        }
      });
  }

  ngOnDestroy(): void {
    this.onDestroy$.next('');
  }

  submitForReview() {
    if (this.createdLiveClass?.id) {
      this.store.dispatch(
        LiveClassActions.requestForReview({
          liveClassId: this.createdLiveClass.id,
        })
      );
    }
  }

  publishClass() {
    if (this.createdLiveClass?.id) {
      this.store.dispatch(
        LiveClassActions.publishLiveClass({
          liveClassId: this.createdLiveClass.id,
        })
      );
    }
  }
}
